import { tokens as o } from "./atoms-v257.js";
const e = 4, c = ["4/5", "4/3", "3/4", "3/4"], i = 100, s = {
  // Animation state for slide that is currently focused.
  active: {
    opacity: 1,
    scale: 1,
    x: 0
  },
  // Animation state for slide that is exiting to either side.
  exit: (t) => ({
    opacity: 0,
    scale: 1,
    x: t > 0 ? "-100%" : "100%"
  }),
  // Animation state for slide that is entering from either side.
  incoming: (t) => ({
    opacity: 0,
    scale: 1.2,
    x: t > 0 ? "100%" : "-100%"
  })
}, a = {
  duration: o.motion.duration.slow["01"] / 1e3,
  ease: o.motion.easing.entrance
}, I = {
  // When the carousel is at the end, the last slide should show less elasticity when dragging to the left.
  end: { left: 0.05, right: 1 },
  // When the carousel is at the start, the first slide should show less elasticity when dragging to the right.
  start: { left: 1, right: 0.05 }
};
export {
  I as DRAG_ELASTIC,
  e as MAX_GRID_SLIDES,
  a as SLIDE_TRANSITION,
  s as SLIDE_VARIANTS,
  i as SWIPE_THRESHOLD,
  c as VARIANT_1_ASPECT_RATIOS
};
